export default __webpack_public_path__ + "static/media/background-content.da7fc324.png";